import { hc } from "hono/client";
import type { AppType } from "./app.ts";

/** Typed RPC client shared with the SPA (and future desktop/CLI clients). */
export const createApiClient = (baseUrl: string, init?: Parameters<typeof hc>[1]) =>
  hc<AppType>(baseUrl, init);

export type ApiClient = ReturnType<typeof createApiClient>;
